import(/* webpackMode: "eager" */ "/app/src/app/error.jsx");
